import { Box, PaperProps, Typography } from "@mui/material";
import { SingleValueDonutChart } from "components/atoms/SingleValueDonutChart";
import { WidgetHeader } from "components/atoms/WidgetHeader";
import { WidgetPaper } from "components/atoms/WidgetPaper";
import { ReactElement } from "react";

interface Props {
  header: string | ReactElement;
  count: number;
  totalCount: number;
  donutColor: string;
  donutBackgroundColor: string;
  donutSize: number;
  description?: string | ReactElement;
  donutTextColor?: string;
  paperProps?: PaperProps;
  paperTextColor?: string;
  dataUnknown?: boolean;
}

export const DonutChart = ({
  header,
  description,
  count,
  totalCount,
  paperProps,
  donutColor,
  donutBackgroundColor,
  donutTextColor,
  donutSize,
  paperTextColor,
  dataUnknown,
}: Props) => {
  return (
    <WidgetPaper
      {...paperProps}
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "left",
          flex: 1,
          justifyContent: "space-between",
          flexDirection: "column",
          maxWidth: "70%",
        }}
      >
        <WidgetHeader
          label={header}
          description={description}
          labelStyle={{ color: paperTextColor ? paperTextColor : "auto" }}
          descriptionStyle={{ color: paperTextColor ? paperTextColor : "auto" }}
        />
        <Typography
          sx={(theme) => ({
            fontSize: "72px",
            lineHeight: "72px",
            fontWeight: 700,
            fontFamily: theme.typography.fontFamily,
            color: "white",
          })}
        >
          {dataUnknown ? "?" : `${count}/${totalCount}`}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "top",
          flex: 1,
          justifyContent: "flex-end",
        }}
      >
        <SingleValueDonutChart
          value={
            !totalCount
              ? 0
              : Math.min(Math.round((count / totalCount) * 100), 100)
          }
          color={donutColor}
          backgroundColor={donutBackgroundColor}
          textColor={donutTextColor}
          size={donutSize}
        />
      </Box>
    </WidgetPaper>
  );
};
